module.exports = __webpack_public_path__ + "static/img/full_screen.53b454e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/full_screen.png
// module id = n1QG
// module chunks = 1